import React from 'react';
import { ChunkyPlusIcon } from '../../icons';
import './AddListing.css';

export interface AddListingProps {
    title: string;
    subtitle?: string;
    onClick?: () => void;
}

export const AddListing: React.FC<AddListingProps> = ({
    title,
    subtitle,
    onClick,
}) => {
    return (
        <div className="add-listing" onClick={onClick}>
            <div className="add-listing__icon-wrapper">
                <ChunkyPlusIcon style={{ width: '26px', height: '26px' }} color="rgba(171, 171, 171, 0.8)" />
            </div>
            <div className="add-listing__content">
                <div className="add-listing__title">{title}</div>
                {subtitle && <div className="add-listing__subtitle">{subtitle}</div>}
            </div>
        </div>
    );
};
